var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadeau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.793 14.2917V40.8333M24.793 14.2917H17.5742C16.5106 14.2917 15.4905 13.8615 14.7384 13.0957C13.9863 12.3299 13.5638 11.2913 13.5638 10.2083C13.5638 9.12537 13.9863 8.08675 14.7384 7.32098C15.4905 6.55521 16.5106 6.125 17.5742 6.125C23.1888 6.125 24.793 14.2917 24.793 14.2917ZM24.793 14.2917H32.0117C33.0753 14.2917 34.0954 13.8615 34.8475 13.0957C35.5996 12.3299 36.0221 11.2913 36.0221 10.2083C36.0221 9.12537 35.5996 8.08675 34.8475 7.32098C34.0954 6.55521 33.0753 6.125 32.0117 6.125C26.3971 6.125 24.793 14.2917 24.793 14.2917ZM10.5013 24.5H39.0846V36.3417C39.0846 38.6285 39.0846 39.772 38.6396 40.6455C38.2481 41.4138 37.6234 42.0385 36.8551 42.4299C35.9816 42.875 34.8382 42.875 32.5513 42.875H17.0346C14.7478 42.875 13.6043 42.875 12.7308 42.4299C11.9625 42.0385 11.3378 41.4138 10.9464 40.6455C10.5013 39.772 10.5013 38.6285 10.5013 36.3417V24.5ZM9.68464 24.5H39.9013C41.0447 24.5 41.6165 24.5 42.0532 24.2775C42.4374 24.0817 42.7497 23.7694 42.9454 23.3852C43.168 22.9485 43.168 22.3768 43.168 21.2333V17.5583C43.168 16.4149 43.168 15.8432 42.9454 15.4064C42.7497 15.0223 42.4374 14.7099 42.0532 14.5142C41.6165 14.2917 41.0447 14.2917 39.9013 14.2917H9.68464C8.54119 14.2917 7.96947 14.2917 7.53274 14.5142C7.14857 14.7099 6.83624 15.0223 6.6405 15.4064C6.41797 15.8432 6.41797 16.4149 6.41797 17.5583V21.2333C6.41797 22.3768 6.41797 22.9485 6.6405 23.3852C6.83624 23.7694 7.14857 24.0817 7.53274 24.2775C7.96947 24.5 8.54119 24.5 9.68464 24.5Z",
    stroke: "url(#paint0_linear_1127_28227)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1127_28227",
    x1: 6.41797,
    y1: 42.875,
    x2: 43.168,
    y2: 42.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadeau);
export default __webpack_public_path__ + "static/media/cadeau.f06eee855a3f8449d4e0d0a2c3e08ab2.svg";
export { ForwardRef as ReactComponent };